import React from "react";
import ErrorPage from "../Notification/Error";

function Setting({ props }) {
  const {
    onChangePassword,
    onChecking,
    isError,
    loading,
    isCheck,
    onView,
    isView,
    password,
  } = props;
  return (
    <div className="w-full">
      <div name="password-form" className="mb-8 lg:mb-5 lg:w-2/5">
        <div className=" mb-3 flex items-center">
          <p className="m-0 login-title-form text-xl lg:text-2xl">Password</p>

          {isCheck && (
            <img
              className="ml-2 w-6"
              src={
                process.env.REACT_APP_BASE_URL +
                `/assets/icon/ic_check_true.svg`
              }
              alt="icon-checking"
            />
          )}
        </div>
        <div className="login-input-wrapper">
          <input
            autoComplete="off"
            value={password.password_lama}
            disabled={loading}
            onChange={onChangePassword}
            name="password_lama"
            type={isView ? "text" : "password"}
            className={`${
              loading ? "input-disabled" : "form-input-icon"
            } outline-none w-full p-3`}
            placeholder="Masukkan password anda"
          />
          <img
            className="cursor-pointer w-5"
            onClick={onView}
            src={
              process.env.REACT_APP_BASE_URL +
              `/assets/icon/${isView ? "ic_forgot.svg" : "ic_hide.svg"}`
            }
            alt="icon-forgot"
          />
        </div>

        {isError
          ? isError.length > 0
            ? isError
                .filter((it) => it.type === "password_lama")
                .map((its, idx) => (
                  <ErrorPage key={idx} props={{ idx, message: its.message }} />
                ))
            : null
          : null}
      </div>

      <div className="flex items-center mb-5">
        <div className="ml-1 mr-3 lg:mr-4">
          <img
            src={
              process.env.REACT_APP_BASE_URL + "/assets/icon/ic_info_blue.svg"
            }
            alt="icon-info-blue"
            className="w-5 lg:w-4"
          />
        </div>
        <p className="header-content colors-gray text-xs lg:text-base">
          Masukkan password lama anda untuk mengganti dengan password baru
        </p>
      </div>

      <button
        onClick={onChecking}
        className={`${
          loading ? "btn-loading" : "btn-blue"
        } btn-blue w-full lg:w-60 p-3 px-8 mb-12 focus:outline-none`}
      >
        <div className="flex items-center justify-center">
          <p className="text-white font-semibold lg:text-lg">
            {loading ? "Loading" : "Submit"}
          </p>
        </div>
      </button>

      <div name="new-password-form" className="mb-8 lg:mb-5 lg:w-2/5">
        <div className=" mb-3 flex justify-between items-center">
          <p className="m-0 login-title-form text-xl lg:text-2xl">
            Password Baru
          </p>
        </div>
        <div className="login-input-wrapper">
          <input
            autoComplete="off"
            value={password.password_baru}
            onChange={onChangePassword}
            name="password_baru"
            disabled={loading || !isCheck}
            type={isView ? "text" : "password"}
            className={`${
              loading || !isCheck ? "input-disabled" : "form-input-icon"
            } outline-none w-full p-3`}
            placeholder="Masukkan password baru anda"
          />
          <img
            onClick={onView}
            className="cursor-pointer w-5"
            src={
              process.env.REACT_APP_BASE_URL +
              `/assets/icon/${isView ? "ic_forgot.svg" : "ic_hide.svg"}`
            }
            alt="icon-forgot"
          />
        </div>

        {isError
          ? isError.length > 0
            ? isError
                .filter((it) => it.type === "password_baru")
                .map((its, idx) => (
                  <ErrorPage key={idx} props={{ idx, message: its.message }} />
                ))
            : null
          : null}
      </div>

      <div name="c-password-form" className="mb-8 lg:mb-5 lg:w-2/5">
        <div className=" mb-3 flex justify-between items-center">
          <p className="m-0 login-title-form text-xl lg:text-2xl">
            Konfirmasi Password Baru
          </p>
        </div>
        <div className="login-input-wrapper">
          <input
            autoComplete="off"
            value={password.c_password_baru}
            onChange={onChangePassword}
            name="c_password_baru"
            disabled={loading || !isCheck}
            type={isView ? "text" : "password"}
            className={`${
              loading || !isCheck ? "input-disabled" : "form-input-icon"
            } outline-none w-full p-3`}
            placeholder="Masukkan kembali password baru anda"
          />
          <img
            onClick={onView}
            className="cursor-pointer w-5"
            src={
              process.env.REACT_APP_BASE_URL +
              `/assets/icon/${isView ? "ic_forgot.svg" : "ic_hide.svg"}`
            }
            alt="icon-forgot"
          />
        </div>

        {isError
          ? isError.length > 0
            ? isError
                .filter((it) => it.type === "c_password_baru")
                .map((its, idx) => (
                  <ErrorPage key={idx} props={{ idx, message: its.message }} />
                ))
            : null
          : null}
      </div>
    </div>
  );
}

export default Setting;
